import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import * as R from 'ramda';

import {Lookup as DXLookup} from 'devextreme-react';


export default class Lookup extends Component {
    constructor(props) {
        super(props);

        this.fieldTemplate = this.fieldTemplate.bind(this);
        this.groupTemplate = this.groupTemplate.bind(this);
        this.itemTemplate = this.itemTemplate.bind(this);
    }

    fieldTemplate(template_id) {
        var tmpl = window[template_id];
        return function(itemData, itemIndex, element) {
            // const d = window.document.createElement('div');
            ReactDOM.render(tmpl(itemData), element);
            // element.append(d.firstChild);
        }
    }

    groupTemplate(template_id) {
        var tmpl = window[template_id];
        return function(itemData, itemIndex, element) {
            // const d = window.document.createElement('div');
            ReactDOM.render(tmpl(itemData), element);
            // element.append(d.firstChild);
        }
    }

    itemTemplate(template_id) {
        var tmpl = window[template_id];
        return function(itemData, itemIndex, element) {
            // const d = window.document.createElement('div');
            ReactDOM.render(tmpl(itemData), element);
            // element.append(d.firstChild);
        }
    }

    render() {
        const dataAttributes = {};
        if (this.props.loading_state && this.props.loading_state.is_loading) {
            dataAttributes['data-dash-is-loading'] = true;
        }

        let {fieldTemplate, groupTemplate, itemTemplate} = this.props;

        if (fieldTemplate && typeof fieldTemplate === 'string' && fieldTemplate !== 'group'){
            fieldTemplate = this.fieldTemplate(fieldTemplate);
        }

        if (groupTemplate && typeof groupTemplate === 'string' && groupTemplate !== 'group'){
            groupTemplate = this.groupTemplate(groupTemplate);
        }

        if (itemTemplate && typeof itemTemplate === 'string' && itemTemplate !== 'item'){
            itemTemplate = this.itemTemplate(itemTemplate);
        }

        return (
            <DXLookup
                {...R.omit(['loading_state', 'setProps'], this.props)}
                {...dataAttributes}
                fieldTemplate={fieldTemplate}
                groupTemplate={groupTemplate}
                itemTemplate={itemTemplate}
            />
        );
    }
}

Lookup.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,

    /**
     * Specifies the shortcut key that sets focus on the UI component
     */
    accessKey: PropTypes.string,
    /**
     * Specifies whether or not the UI component changes its state when interacting with a user
     */
    activeStateEnabled: PropTypes.bool,
    /**
     * The text displayed on the Apply button
     */
    applyButtonText: PropTypes.string,
    /**
     * Specifies the way an end-user applies the selected value
     */
    applyValueMode: PropTypes.oneOf(['instantly', 'useButtons']),
    /**
     * The text displayed on the Cancel button
     */
    cancelButtonText: PropTypes.string,
    /**
     * Specifies whether or not the UI component cleans the search box when the popup window is displayed
     */
    cleanSearchOnOpening: PropTypes.bool,
    /**
     * The text displayed on the Clear button
     */
    clearButtonText: PropTypes.string,
    /**
     * Binds the UI component to data
     */
    dataSource: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.arrayOf(PropTypes.any)]),
    /**
     * Specifies whether to render the drop-down field's content when it is displayed. If false, the content is rendered immediately.
     */
    deferRendering: PropTypes.bool,
    /**
     * Specifies whether the UI component responds to user interaction
     */
    disabled: PropTypes.bool,
    /**
     * Specifies the data field whose values should be displayed. Defaults to "text" when the data source contains objects
     */
    displayExpr: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * Returns the value currently displayed by the UI component
     */
    displayValue: PropTypes.string,
    /**
     * Specifies whether to vertically align the drop-down menu so that the selected item is in its center. Applies only in Material Design themes.
     */
    dropDownCentered: PropTypes.bool,
    /**
     * Configures the drop-down field
     */
    dropDownOptions: PropTypes.object,
    /**
     * Specifies the global attributes to be attached to the UI component's container element
     */
    elementAttr: PropTypes.object,
    /**
     * An alias for the fieldTemplate property specified in React. Accepts a custom component.
     */
    fieldComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    /**
     * An alias for the fieldTemplate property specified in React. Accepts a rendering function.
     */
    fieldRender: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * Specifies a custom template for the input field
     */
    fieldTemplate: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    /**
     * Specifies whether the UI component can be focused using keyboard navigation
     */
    focusStateEnabled: PropTypes.bool,
    /**
     * An alias for the groupTemplate property specified in React. Accepts a custom component.
     */
    groupComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    /**
     * Specifies whether data items should be grouped
     */
    grouped: PropTypes.bool,
    /**
     * An alias for the groupTemplate property specified in React. Accepts a rendering function.
     */
    groupRender: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * Specifies a custom template for group captions
     */
    groupTemplate: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    /**
     * Specifies the UI component's height
     */
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Specifies text for a hint that appears when a user pauses on the UI component
     */
    hint: PropTypes.string,
    /**
     * Specifies whether the UI component changes its state when a user pauses on it
     */
    hoverStateEnabled: PropTypes.bool,
    /**
     * Specifies the attributes to be passed on to the underlying HTML element
     */
    inputAttr: PropTypes.object,
    /**
     * Specifies or indicates whether the editor's value is valid
     */
    isValid: PropTypes.bool,
    /**
     * An alias for the itemTemplate property specified in React. Accepts a custom component.
     */
    itemComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    /**
     * An alias for the itemTemplate property specified in React. Accepts a rendering function.
     */
    itemRender: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * An array of items displayed by the UI component
     */
    items: PropTypes.arrayOf(PropTypes.any),
    /**
     * Specifies a custom template for items
     */
    itemTemplate: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    /**
     * The minimum number of characters that must be entered into the text box to begin a search. Applies only if searchEnabled is true.
     */
    minSearchLength: PropTypes.number,
    /**
     * The value to be assigned to the name attribute of the underlying HTML element
     */
    name: PropTypes.string,
    /**
     * The text displayed on the button used to load the next page from the data source
     */
    nextButtonText: PropTypes.string,
    /**
     * The text or HTML markup displayed by the UI component if the item collection is empty
     */
    noDataText: PropTypes.string,
    /**
     * A function that is executed once the drop-down editor is closed
     */
    onClosed: PropTypes.func,
    /**
     * A function that is executed when the UI component's content is ready and each time the content is changed
     */
    onContentReady: PropTypes.func,
    /**
     * A function that is executed before the UI component is disposed of
     */
    onDisposing: PropTypes.func,
    /**
     * A function used in JavaScript frameworks to save the UI component instance
     */
    onInitialized: PropTypes.func,
    /**
     * A function that is executed when a collection item is clicked or tapped
     */
    onItemClick: PropTypes.func,
    /**
     * A function that is executed once the drop-down editor is opened
     */
    onOpened: PropTypes.func,
    /**
     * A function that is executed after a UI component property is changed
     */
    onOptionChanged: PropTypes.func,
    /**
     * A function that is executed before the next page is loaded
     */
    onPageLoading: PropTypes.func,
    /**
     * A function that is executed when the "pull to refresh" gesture is performed. Supported in mobile themes only
     */
    onPullRefresh: PropTypes.func,
    /**
     * A function that is executed on each scroll gesture
     */
    onScroll: PropTypes.func,
    /**
     * A function that is executed when a collection item is selected or selection is canceled
     */
    onSelectionChanged: PropTypes.func,
    /**
     * A function that is executed after the UI component's value is changed
     */
    onValueChanged: PropTypes.func,
    /**
     * Specifies whether or not the drop-down editor is displayed
     */
    opened: PropTypes.bool,
    /**
     * Specifies the text shown in the pullDown panel, which is displayed when the list is scrolled to the bottom
     */
    pageLoadingText: PropTypes.string,
    /**
     * Specifies whether the next page is loaded when a user scrolls the UI component to the bottom or when the "next" button is clicked
     */
    pageLoadMode: PropTypes.oneOf(['nextButton', 'scrollBottom']),
    /**
     * The text displayed by the UI component when nothing is selected
     */
    placeholder: PropTypes.string,
    /**
     * Specifies the text displayed in the pullDown panel when the list is pulled below the refresh threshold
     */
    pulledDownText: PropTypes.string,
    /**
     * Specifies the text shown in the pullDown panel while the list is being pulled down to the refresh threshold
     */
    pullingDownText: PropTypes.string,
    /**
     * A Boolean value specifying whether or not the UI component supports the "pull down to refresh" gesture
     */
    pullRefreshEnabled: PropTypes.bool,
    /**
     * Specifies the text displayed in the pullDown panel while the list is being refreshed
     */
    refreshingText: PropTypes.string,
    /**
     * Switches the UI component to a right-to-left representation
     */
    rtlEnabled: PropTypes.bool,
    /**
     * Specifies whether the search panel is visible
     */
    searchEnabled: PropTypes.bool,
    /**
     * Specifies a data object's field name or an expression whose value is compared to the search string
     */
    searchExpr: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    /**
     * Specifies a comparison operation used to search UI component items
     */
    searchMode: PropTypes.oneOf(['contains', 'startswith', 'equals']),
    /**
     * The text that is provided as a hint in the lookup's search bar
     */
    searchPlaceholder: PropTypes.string,
    /**
     * Specifies a delay in milliseconds between when a user finishes typing, and the search is executed
     */
    searchTimeout: PropTypes.number,
    /**
     * Specifies whether to display the Cancel button in the lookup window
     */
    showCancelButton: PropTypes.bool,
    /**
     * Specifies whether to display the Clear button in the lookup window
     */
    showClearButton: PropTypes.bool,
    /**
     * Specifies whether or not the UI component displays unfiltered values until a user types a number of characters exceeding the minSearchLength property value
     */
    showDataBeforeSearch: PropTypes.bool,
    /**
     * Specifies how the UI component's text field is styled
     */
    stylingMode: PropTypes.oneOf(['outlined', 'underlined', 'filled']),
    /**
     * Specifies the number of the element when the Tab key is used for navigating
     */
    tabIndex: PropTypes.number,
    /**
     * An alias for the titleTemplate property specified in React. Accepts a custom component.
     */
    titleComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    /**
     * An alias for the titleTemplate property specified in React. Accepts a rendering function.
     */
    titleRender: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * Specifies whether or not the UI component uses native scrolling
     */
    useNativeScrolling: PropTypes.bool,
    /**
     * Specifies whether to show lookup contents in the Popover UI component
     */
    usePopover: PropTypes.bool,
    /**
     * Information on the broken validation rule. Contains the first item from the validationErrors array.
     */
    validationError: PropTypes.object,
    /**
     * An array of the validation rules that failed
     */
    validationErrors: PropTypes.arrayOf(PropTypes.object),
    /**
     * Specifies how the message about the validation rules that are not satisfied by this editor's value is displayed
     */
    validationMessageMode: PropTypes.oneOf(['always', 'auto']),
    /**
     * Indicates or specifies the current validation status
     */
    validationStatus: PropTypes.oneOf(['valid', 'invalid', 'pending' ]),
    /**
     * Specifies the currently selected value. May be an object if dataSource contains objects and valueExpr is not set.
     */
    value: PropTypes.any,
    /**
     * Specifies the DOM events after which the UI component's search results should be updated
     */
    valueChangeEvent: PropTypes.string,
    /**
     * Specifies which data field provides unique values to the UI component's value
     */
    valueExpr: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * Specifies whether the UI component is visible
     */
    visible: PropTypes.bool,
    /**
     * Specifies the UI component's width
     */
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Specifies whether text that exceeds the drop-down list width should be wrapped
     */
    wrapItemText: PropTypes.bool,

    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func,
    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
};

Lookup.defaultProps = {
    accessKey: null,
    activeStateEnabled: true,
    applyButtonText: 'OK',
    applyValueMode: 'instantly',
    cancelButtonText: 'Cancel',
    cleanSearchOnOpening: true,
    clearButtonText: 'Clear',
    dataSource: null,
    deferRendering: true,
    disabled: false,
    // displayExpr: undefined,
    // displayValue: undefined,
    dropDownCentered: false, // true (Material)
    dropDownOptions: {},
    elementAttr: {},
    fieldComponent: null,
    fieldRender: null,
    fieldTemplate: null,
    focusStateEnabled: true,
    groupComponent: null,
    grouped: false,
    groupRender: null,
    groupTemplate: 'group',
    // height: undefined,
    // hint: undefined,
    hoverStateEnabled: true,
    inputAttr: {},
    isValid: true,
    itemComponent: null,
    itemRender: null,
    items: null,
    itemTemplate: 'item',
    minSearchLength: 0,
    name: '',
    nextButtonText: 'More',
    noDataText: 'No data to display',
    onClosed: null,
    onContentReady: null,
    onDisposing: null,
    onInitialized: null,
    onItemClick: null,
    onOpened: null,
    onOptionChanged: null,
    onPageLoading: null,
    onPullRefresh: null,
    onScroll: null,
    onSelectionChanged: null,
    onValueChanged: null,
    opened: false,
    pageLoadingText: 'Loading...', // '' (Material)
    pageLoadMode: 'scrollBottom',
    placeholder: 'Select',
    pulledDownText: 'Release to refresh...', // '' (Material)
    pullingDownText: 'Pull down to refresh...', // '' (Material)
    pullRefreshEnabled: false,
    refreshingText: 'Refreshing...', // '' (Material)
    rtlEnabled: false,
    searchEnabled: false,
    searchExpr: null,
    searchMode: 'contains',
    searchPlaceholder: 'Search',
    searchTimeout: 500,
    showCancelButton: true, // false (Material)
    showClearButton: false,
    showDataBeforeSearch: false,
    stylingMode: 'outlined', // 'underlined' (Material)
    tabIndex: 0,
    titleComponent: null,
    titleRender: null,
    useNativeScrolling: false, // true, false (desktop except Mac)
    usePopover: false, // true (desktop, iOS), false (Material)
    validationError: null,
    validationErrors: null,
    validationMessageMode: 'auto',
    validationStatus: 'valid',
    value: null,
    valueChangeEvent: 'input change keyup',
    valueExpr: 'this',
    visible: true,
    // width: undefined,
    wrapItemText: false,
};
